<template>
  <div class="applicant-form">
    <validation-observer ref="validator" v-slot="{ invalid, handleSubmit }" tag="div">
      <t-form @submit.native.prevent="handleSubmit(submit)">
        <t-validation-wrapper
          vid="date_of_birth"
          :name="$t('fields.date_of_birth')"
          :label="$t('fields.date_of_birth')"
          rules="required|age:16"
        >
          <ApplicantDateOfBirthHelp slot="help" />
          <t-datepicker v-model="form.date_of_birth">
            <t-icon slot="right" icon="baby" />
          </t-datepicker>
        </t-validation-wrapper>

        <t-validation-wrapper
          v-if="isJuniorApplicant"
          vid="graduated_at"
          :name="$t('fields.graduated_at')"
          :label="$t('fields.apprenticeship_finished')"
          rules="required"
        >
          <t-datepicker v-model="form.graduated_at">
            <t-icon slot="right" icon="graduation-cap" />
          </t-datepicker>
        </t-validation-wrapper>

        <t-validation-wrapper vid="occupation_ids" :name="$t('fields.desired_occupations')">
          <Occupations v-model="form.occupation_ids" />
          <p class="text--grey mt-3">
            <em>{{ $t('hints.occupations', { tenant_support_mail: tenantSupportMail }) }}</em>
          </p>
        </t-validation-wrapper>

        <slot name="footer" :invalid="invalid" :loading="loading" />
      </t-form>
    </validation-observer>
  </div>
</template>
<script>
import Vue from 'vue';
import FormBaseMixin from '../../FormBaseMixin';
import Applicant from '~/models/Applicant';
import TDatepicker from '~/components/TDatepicker';
import Occupations from '~/components/Fields/Occupations';
import ExperienceTierEnum from '~/enums/ExperienceTierEnum';
import ApplicantDateOfBirthHelp from '~/components/Help/ApplicantDateOfBirthHelp.vue';

export default Vue.extend({
  components: {
    TDatepicker,
    Occupations,
    ApplicantDateOfBirthHelp,
  },

  mixins: [FormBaseMixin],

  props: {
    applicant: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    form: null,
  }),

  created() {
    this.form = this.getForm(this.applicant);
  },

  computed: {
    isJuniorApplicant() {
      return this.applicant?.experience_tier === ExperienceTierEnum.JUNIOR;
    },

    tenantSupportMail() {
      return this.$store.getters['tenant/tenant']?.meta?.support_email;
    },
  },

  methods: {
    async request(payload) {
      const model = await new Applicant({ id: this.applicant.id, ...payload }).patch();
      this.$emit('updated', model);

      return model;
    },

    getForm(model = null) {
      return {
        date_of_birth: model?.date_of_birth,
        graduated_at: model?.graduated_at,
        occupation_ids: model?.occupation_ids || [],
      };
    },

    getPayload() {
      return { ...this.form };
    },
  },
});
</script>
